module.exports = __webpack_public_path__ + "img/ic_12_next_neobet.465a8801.svg";